module.exports = __webpack_public_path__ + "static/img/bcg_revise.9123adb2.png";